import { styled } from "styled-components";

export const MyInfoEditWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;
